/* eslint-disable */
import * as React from "react";
import { WithStyles, withStyles } from "@material-ui/styles";
import { Box, Typography, TextField, Button, Grid, Tooltip } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import { isIE } from "react-device-detect";
import Footer from "../../../../layouts/Footer";
import Header from "../../../../layouts/Header";
import Layout from "../../../../layouts/Layout";
import Link from "../../../../shared/ui/Link";
import { useRegistration, RequestStatus, User } from "../../shared";
import { AuthError } from "../../shared";
import { useAuthError } from "../../shared";
import { loginPatt, namePatt, INITIAL_STATE, AVAILEBLE_EMAIL_DOMAINS } from "./constants/constants";
import messages from "./constants/messages";
import { State } from "./constants/types";
import { styles } from "./constants/styles";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Avatar from "@material-ui/core/Avatar";
import { useDepartments, Department } from "../../../dictionaries/shared";
import { ComboBoxField } from "../../../../components/ComboBoxField";
import { PasswordField } from "../../../../shared/ui/PasswordField";
import { useUserSettings } from "../../../user/components/UserSettings/useUserSettings";
import { ChangeEvent } from "react";
import { browserHistory } from "../../../../routes/history";
import { passwordValidate } from "../../../../shared";

type Props = WithStyles<typeof styles>;

const RegisterPage: React.FC<Props> = (props: Props) => {
  const [state, setState] = React.useState<State>(INITIAL_STATE);
  const [status, registration] = useRegistration();
  const [errorCode] = useAuthError();
  const { state: statePassword, changeField } = useUserSettings();
  const [, departmentsWithNamesDeleted] = useDepartments();

  React.useEffect(() => {
    if (errorCode === AuthError.FailedDependency) {
      browserHistory.push("/login/register-complete");
    }
  }, [errorCode]);

  const getErrors = (id: string, value: string) => {
    const { password = "", confirmPassword = "" } = statePassword;
    let errors: any = {};
    if (id === "login") {
      let loginError = !value;
      if (!loginError) {
        const login = value.split("@")[0] || "";
        loginError = !login.match(loginPatt);
      }
      errors[id] = loginError;

      const domain = value.split("@")[1] || "";
      const domainError = !AVAILEBLE_EMAIL_DOMAINS.some((d) => d === domain);
      errors["domain"] = domainError;
    }
    if (id === "name" || id === "surname") {
      const nameOrSurnameError = !value || !value.match(namePatt);
      errors[id] = nameOrSurnameError;
    }
    if (id === "department") {
      errors[id] = !value;
    }
    if (id === "password" || id === "confirmPassword") {
      errors["password"] =
        !value || !passwordValidate(password).length || (id === "password" ? value !== confirmPassword : value !== password);
      errors["confirmPassword"] =
        !value || !passwordValidate(password).length || (id === "password" ? value !== confirmPassword : value !== password);
    }

    return errors;
  };

  const handleChangeText = (id: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
    if (id === "password" || id === "confirmPassword") {
      changeField(id, event.target.value.trim());
    }
    let domainError = state.errors.domain;
    let errors = {};

    if (state.showErrorMessage) {
      errors = getErrors(id, event.target.value.trim());
    }
    setState({
      ...state,
      [id]: event.target.value.trim(),
      errors: {
        ...state.errors,
        domain: domainError,
        ...errors,
      },
    });
  };

  const handleChangeDepartment = (event: ChangeEvent<{}>, value: any) => {
    if (value) {
      setState({ ...state, department: value.id, errors: { ...state.errors, department: false } });
    } else {
      setState({ ...state, department: 0, errors: { ...state.errors, department: true } });
    }
  };

  const handleApply = () => {
    const isValid = checkValidity();
    if (isValid) {
      const { password } = statePassword;
      const { name, surname, login: email, department } = state;
      const user: User = { name, surname, departmentId: department, email, password };
      registration(user);
    }
  };

  const checkValidity = () => {
    const { password = "", confirmPassword = "" } = statePassword;

    let loginError = !state.login;
    if (!loginError) {
      const login = state.login.split("@")[0] || "";
      loginError = !login.match(loginPatt);
    }
    const domain = state.login.split("@")[1] || "";
    const domainError = !AVAILEBLE_EMAIL_DOMAINS.some((d) => d === domain);
    const nameError = !state.name || !state.name.match(namePatt);
    const surnameError = !state.surname || !state.surname.match(namePatt);
    const departmentError = !state.department;
    const passwordError = !password || !!passwordValidate(password).length || confirmPassword !== password;
    const confirmPasswordError =
      !confirmPassword || !!passwordValidate(confirmPassword).length || confirmPassword !== password;
    const errors = [
      loginError,
      nameError,
      surnameError,
      passwordError,
      confirmPasswordError,
      departmentError,
      domainError,
    ];
    const showErrorMessage = errors.some((error) => error === true);

    setState({
      ...state,
      errors: {
        login: loginError,
        name: nameError,
        surname: surnameError,
        password: passwordError,
        confirmPassword: confirmPasswordError,
        department: departmentError,
        domain: domainError,
      },
      showErrorMessage,
    });
    return errors.every((error) => error === false);
  };

  const isEmptyDomain = () => {
    if (state.login.length) {
      const domain = state.login.split("@")[1] || "";
      return domain ? false : true;
    }
    return true;
  };

  const renderHelperText = (id: string) => {
    if (id === "name" || id === "surname") {
      return (
        (!state[id].length && state.showErrorMessage && <FormattedMessage {...messages.fieldIsRequired} />) ||
        (state.showErrorMessage && state.errors[id] && (
          <Tooltip title={<FormattedMessage {...messages.checkCorrectness} />}>
            <span>
              <FormattedMessage {...messages.checkCorrectness} />
            </span>
          </Tooltip>
        ))
      );
    }

    if (id === "department" && !state.department) {
      return <FormattedMessage {...messages.fieldIsRequired} />;
    }

    if (id === "login") {
      return (
        (!state.login.length && state.showErrorMessage && <FormattedMessage {...messages.fieldIsRequired} />) ||
        (!state.errors.login && state.errors.domain && isEmptyDomain() && (
          <FormattedMessage {...messages.checkCorrectness} />
        )) ||
        (!state.errors.login && state.errors.domain && <FormattedMessage {...messages.emailNotInSystem} />) ||
        (errorCode !== AuthError.None && errorCode === AuthError.EmailExists && (
          <FormattedMessage {...messages.emailExists} />
        ))
      );
    }

    if (id === "password" || id === "confirmPassword") {
      const { password = "", confirmPassword = "" } = statePassword;

      if (statePassword[id]) {
        const passwordErrors = passwordValidate(statePassword[id]);
        return (
          (state.showErrorMessage && passwordErrors.length && (
            <FormattedMessage {...messages.checkCorrectness} />
          )) ||
          (state.showErrorMessage && password !== confirmPassword && (
            <FormattedMessage {...messages.passwordsMustMatch} />
          )) ||
          undefined
        );
      } else {
        return state.showErrorMessage && <FormattedMessage {...messages.fieldIsRequired} />;
      }
    }
    return undefined;
  };

  const { classes } = props;
  const { password = "", confirmPassword = "" } = statePassword;
  const isPending = status === RequestStatus.Pending;
  return (
    <Layout>
      <Header />
      <div className={classes.root}>
        <Box className={classes.box}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5" className={classes.header}>
            <FormattedMessage {...messages.header} />
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                name="name"
                variant="outlined"
                fullWidth
                id="name"
                label={<FormattedMessage {...messages.name} />}
                autoComplete="name"
                value={state.name}
                onChange={handleChangeText("name")}
                inputProps={{ maxLength: 50 }}
                error={state.errors.name}
                helperText={renderHelperText("name")}
                InputLabelProps={{ classes: { root: classes.inputLabel }, shrink: isIE ? true : undefined }}
                FormHelperTextProps={{ classes: { root: classes.helperText } }}
                classes={{ root: classes.textField }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="surname"
                variant="outlined"
                fullWidth
                id="surname"
                label={<FormattedMessage {...messages.surname} />}
                autoComplete="surname"
                value={state.surname}
                onChange={handleChangeText("surname")}
                inputProps={{ maxLength: 50 }}
                error={state.errors.surname}
                helperText={renderHelperText("surname")}
                InputLabelProps={{ classes: { root: classes.inputLabel }, shrink: isIE ? true : undefined }}
                FormHelperTextProps={{ classes: { root: classes.helperText } }}
                classes={{ root: classes.textField }}
              />
            </Grid>
            <Grid item xs={12}>
              <ComboBoxField
                key={
                  departmentsWithNamesDeleted && departmentsWithNamesDeleted[0]
                    ? departmentsWithNamesDeleted[0].id
                    : "nodata"
                }
                options={departmentsWithNamesDeleted}
                getOptionLabel={(option) => option.name}
                inputLabel={messages.department}
                defaultValue={departmentsWithNamesDeleted.find((item) => item.isDeleted === false)}
                filterOptions={(options: Department[], state: any) => {
                  return options.filter(
                    (item) =>
                      item.isDeleted === false &&
                      (!!state.inputValue.length
                        ? item.name.toLowerCase().includes(state.inputValue.toLowerCase())
                        : true),
                  );
                }}
                onChange={handleChangeDepartment}
                inputLabelClassName={classes.inputLabel}
                className={classes.textField}
                error={state.errors.department}
                helperText={renderHelperText("department") || undefined}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                fullWidth
                id="login"
                label={<FormattedMessage {...messages.login} />}
                name="login"
                autoComplete="login"
                value={state.login}
                onChange={handleChangeText("login")}
                InputLabelProps={{ classes: { root: classes.inputLabel }, shrink: isIE ? true : undefined }}
                error={
                  state.errors.login ||
                  state.errors.domain ||
                  (errorCode !== AuthError.None && errorCode === AuthError.EmailExists)
                }
                helperText={renderHelperText("login")}
                FormHelperTextProps={{ classes: { root: classes.helperText } }}
                classes={{ root: classes.textField }}
                InputProps={{
                  classes: { input: classes.inputRoot },
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <PasswordField
                mode={"password"}
                InputLabelProps={{ classes: { root: classes.inputLabel }, shrink: isIE ? true : undefined }}
                variant="outlined"
                fullWidth
                value={password}
                onChange={handleChangeText("password")}
                customErrorState={state.errors.password}
                customLabel={messages.password}
                inputProps={{ classes: { input: classes.inputRoot } }}
                isHaveValidateText={false}
                customHelperText={renderHelperText("password") || undefined}
                FormHelperTextProps={{ classes: { root: classes.helperText } }}
              />
            </Grid>
            <Grid item xs={12}>
              <PasswordField
                mode={"confirmPassword"}
                InputLabelProps={{ classes: { root: classes.inputLabel }, shrink: isIE ? true : undefined }}
                variant="outlined"
                fullWidth
                value={confirmPassword}
                onChange={handleChangeText("confirmPassword")}
                customErrorState={state.errors.confirmPassword}
                customLabel={messages.confirmPassword}
                inputProps={{ classes: { input: classes.inputRoot } }}
                isHaveValidateText={false}
                customHelperText={renderHelperText("confirmPassword") || undefined}
                FormHelperTextProps={{ classes: { root: classes.helperText } }}
              />
            </Grid>
          </Grid>
          <div className={classes.buttonBase}>
            <Button
              className={classes.registerButton}
              variant="contained"
              color="primary"
              onClick={handleApply}
              disabled={isPending}
            >
              <FormattedMessage {...messages.registerButton} />
            </Button>
            <Link className={classes.link} active={true} to={"/login/sign-in"}>
              <Button className={classes.cancelButton} variant="contained" color="secondary" disabled={isPending}>
                <FormattedMessage {...messages.loginButton} />
              </Button>
            </Link>
          </div>
        </Box>
      </div>
      <Footer />
    </Layout>
  );
};

export default withStyles(styles)(RegisterPage);
